import type {CadEntityKind} from '../../types/document/CadEntityTypes';

export type {CadEntityKind} from '../../types/document/CadEntityTypes';

/**
 * CAD 实体类型枚举值。
 *
 * 设计说明：
 * 1. Phase 0 只建立最小文档边界，不迁移现有 Three.js / Worker / Pinia 状态；
 * 2. 这些类型用于稳定 ID、实体注册表与 snapshot adapter 之间共享同一套实体语义；
 * 3. 派生状态如 BRep、Mesh、Render cache 不应作为普通历史实体进入模型事务。
 */
export const CAD_ENTITY_KIND_VALUES = [
    'document',
    'sketch',
    'sketch-entity',
    'sketch-entity-reference',
    'sketch-constraint',
    'sketch-dimension',
    'solver-island',
    'feature',
    'body',
    'assembly',
    'component-instance',
    //------ 线性零部件阵列撤销重做 开始------
    'linear-component-pattern',
    //------ 线性零部件阵列撤销重做 结束------
    'mate',
    'datum',
    'view',
] as const satisfies readonly CadEntityKind[];

/**
 * 判断输入值是否为受支持的 CAD 实体类型。
 *
 * @param value 待判断的字符串。
 * @returns 输入值是否属于 `CadEntityKind`。
 */
export function isCadEntityKind(value: string): value is CadEntityKind {
    return CAD_ENTITY_KIND_VALUES.includes(value as CadEntityKind);
}

/**
 * CAD 实体基础身份信息。
 */
export interface CadEntityIdentity {
    /** 稳定 CAD 实体 ID。 */
    readonly entityId: string;
    /** 实体类型。 */
    readonly kind: CadEntityKind;
}
